import React from "react";
import ImageLoader from "../common/ImageLoader";

const InfoGraph = ({ graphs, className = "" }) => {
  return (
    <section className={`technology-graph ${className}`}>
      <div className="container">
        <div className="technology-graph__header">
          <h2 className="technology-graph__title">
            Monthly insights to help you breathe easier.
          </h2>
          <div className="technology-graph__description">
            <p>
              This first-of-its-kind summary gives you comprehensive insights
              into your air quality each month, for a longer-term look at your
              home health and how it’s evolving.
            </p>
          </div>
        </div>
        <div className="technology-graph__grid">
          {graphs.map(({ title, description, image }, index) => (
            <div className="technology-graph__card" key={index}>
              <div
                className="technology-graph__card-header"
                style={{ maxWidth: index === 2 ? "468px" : "418px" }}
              >
                <h3 className="technology-graph__card-title">{title}</h3>
                <div className="technology-graph__card-description">
                  {description()}
                </div>
              </div>
              <div className="technology-graph__card-image">
                <ImageLoader
                  image={image.src}
                  alt={image.alt}
                  width={image.width}
                  height={image.height}
                  noLazyLoad
                />
              </div>
              {image.caption && (
                <strong className="technology-graph__card-caption">
                  {image.caption}
                </strong>
              )}
            </div>
          ))}
        </div>
        <div className="technology-graph__footer">
          <p>
            🤗 <br />
            <strong>86% of customers</strong>{" "}
            <em>
              say they know more <br /> about their air quality in the first
              seven days.
            </em>
          </p>
        </div>
      </div>
    </section>
  );
};

export default InfoGraph;
